import React from 'react'
import CheckboxField from '@/v2/components/common/CheckboxField'
import SignaturePad from '../SignaturePad'
import { INVALID_ATTR } from '../fields'
import {
  StepCard,
  TitleContainer,
  StepIndicator,
  SectionTitle,
  FieldWrapper,
  RequiredMark,
  TermsBox,
} from '../styles'

const SignatureTerms = ({ setting = {}, values, setValue, errors }) => {
  if (!setting.terms_enabled && !setting.signature_enabled) return null

  return (
    <StepCard>
      <TitleContainer>
        <StepIndicator>✓</StepIndicator>
        <SectionTitle>Agreement</SectionTitle>
      </TitleContainer>

      {setting.terms_enabled && (
        <div
          style={{ marginBottom: 16 }}
          {...(errors.accepts_conditions ? { [INVALID_ATTR]: '' } : {})}
        >
          {/* The terms read as a block of prose, not as a checkbox label: as a
              label the clinic's paragraphs wrapped around a vertically-centred
              box, and the whole legal text became one big toggle target. */}
          {setting.conditions && <TermsBox>{setting.conditions}</TermsBox>}
          <CheckboxField
            label={
              <>
                I accept the terms and conditions <RequiredMark>*</RequiredMark>
              </>
            }
            checked={values.accepts_conditions === true}
            error={errors.accepts_conditions}
            onChange={e => setValue('accepts_conditions', e.target.checked)}
          />
          {setting.link_url && (
            <p style={{ marginTop: 4 }}>
              <a href={setting.link_url} target="_blank" rel="noreferrer">
                {setting.link_title || 'Terms'}
              </a>
            </p>
          )}
        </div>
      )}

      {setting.signature_enabled && (
        <FieldWrapper
          $basis="100%"
          {...(errors.signature ? { [INVALID_ATTR]: '' } : {})}
        >
          <label style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>
            Signature <RequiredMark>*</RequiredMark>
          </label>
          <SignaturePad
            value={values.signature || ''}
            onChange={v => setValue('signature', v)}
          />
          {errors.signature && (
            <p style={{ color: '#b91c1c', fontSize: 13 }}>{errors.signature}</p>
          )}
        </FieldWrapper>
      )}
    </StepCard>
  )
}

export default SignatureTerms
